import {
  Button,
  Checkbox,
  Chip,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  Switch,
  TextField,
  Tooltip,
} from "@material-ui/core";
import React, { useState } from "react";
import translation from "../../../i18n/i18.json";
import useStyles from "./VendorDetail.css";
import CancelIcon from "@material-ui/icons/Cancel";
import { PaymentMethod } from "../../../models/PaymentMethod";
import { CreditPeriodDays } from "../../../models/CreditPeriodDays";
import { TermsTrade } from "../../../models/TermsTrade";
import { SettlementCurrency } from "../../../models/SettlementCurrency";
import { SVATType } from "../../../models/SVATType";
import { WHTCountry } from "../../../models/WHTCountry";
import { WHTType } from "../../../models/WHTType";
import { WHTCode } from "../../../models/WHTCode";
import { VendorDetailState } from "../../../reducers/vendor/VendorDetailReducer";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { VendorDetailPaymentMeta } from "../../../models/VendorDetail/VendorDetailPaymentMeta";
import { useEffect } from "react";
import { Common } from "../../../utils/Common";
import FileUpload from "../../../components/FileUpload/FileUpload";
import {
  acmeNOBvalues,
  FieldsLengthConstants,
  FileUploadTypes,
  InforDisplyaDuration,
  Max_PermittedPayee_For_Vendor,
  RequestStatus,
  VendorCountry,
  VendorRequestViewMode,
  VendorTypeData,
} from "../../../constants/AppConstants";
import { VendorCreateState } from "../../../reducers/vendor/VendorCreateReducer";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { Company } from "../../../models/Company";
import { MasterMetaDataService } from "../../../services/MasterMetaDataService";
import AllActions from "../../../actions";
import { useDispatch } from "react-redux";
import { SAPVendor } from "../../../models/SAPVendor";
import VendorSelectDialog from "../../../components/Vendor/Popup/VendorSelectDialog";
import { Util } from "../../../utils/Util";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import { Country } from "../../../models/Country";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

const icon = <CheckBoxOutlineBlankIcon />;
const checkedIcon = <CheckBoxIcon />;

export default function PaymentDetail(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    getErrorState,
    handleChange,
    isPORequest,
    isWHTAvailable,
    isPanTaxRequired,
    isTrcRequired,
    isTaxDetailsAvailable,
    is1099Required,
    isFielsAvailable,
    isEditableMode,
    vendorDetailMode,
    termstrade,
    crediperioddays,
    settlementcurrency,
    whtcountries,
    whttypes,
    whtcodes,
    paymentmethod,
    handleDelete,    
    getCompareField
  } = props;
  const [openPermittedPayeeDialog, setOpenPermittedPayeeDialog] = useState(false);

  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);

  const createVendor: VendorCreateState = useSelector<
    RootState,
    VendorCreateState
  >((state) => state.vendorCreateDetails);

  const handleChangeAutoCompete = (e: any, input: string, newValue: any) => {
    if (input === "WHTCountry") {
      if (newValue) {
        updateWHTCountryData(newValue.code);
      } else {
        updateWHTCountryData("");
      }
    } else if (input === "alternativeCurrency") {
      // let settlecurencydata: SettlementCurrency | undefined = { code: "", name: "" };
      let selectedCodeList: string[] = [];
      if (newValue) {
        selectedCodeList = newValue.map(function (item: SettlementCurrency) {
          return item.code;
        });
      }
      if (newValue) {
        dispatch(
          AllActions.vendorDetailActions.updateDataField(
            input,
            selectedCodeList
          )
        );
      } else {
        dispatch(AllActions.vendorDetailActions.updateDataField(input, []));
      }
    } else if (input === "orderCurrency") {
      dispatch(
        AllActions.vendorDetailActions.updateOrderCurrency(
          newValue ? newValue.code : ""
        )
      );
    }
  };

  const updateWHTCountryData = (newValue: string) => {
    dispatch(
      AllActions.vendorDetailActions.updateDataField("WHTCountry", newValue)
    );
    dispatch(AllActions.vendorDetailActions.updateDataField("WHTType", ""));
    dispatch(AllActions.vendorDetailActions.updateDataField("WHTCode", ""));
  };

  const handlePermittedPayeeAddPress = (e: any) => {
    setOpenPermittedPayeeDialog(true);
  };

  const handlePermittedPayeeClose = (e: any) => {
    setOpenPermittedPayeeDialog(false);
  };

  const handleUpdatePermittedPayee = (sapVendorList: Array<SAPVendor>) => {
    setOpenPermittedPayeeDialog(false);
    if (sapVendorList && sapVendorList.length > 0) {
      dispatch(
        AllActions.vendorDetailActions.updateDataField(
          "permittedPayeeList",
          sapVendorList.map((row, index) => {
            return row.vendor;
          })
        )
      );
    } else {
      dispatch(
        AllActions.vendorDetailActions.updateDataField("permittedPayeeList", [])
      );
    }
  };

  const filterOptionsOrderCurrency = createFilterOptions({
    stringify: (option: SettlementCurrency) => option.name,
  });

  return (
    <div>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={11}
        lg={12}
        className={classes.formOneWrapper}
      >
        {isPORequest() && (
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={4}
            className={!isEditableMode ? classes.compDisableCls : ""}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.vendor_detail_paymentdetails_termtrd_lbl}
                <label hidden={getCompareField("TermsOfTradeCode")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid
              className={classes.inputWrapper_Req}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Select
                variant="outlined"
                disabled
                value={vendorDetail.TermsOfTrade || ""}
                onChange={handleChange("TermsOfTrade")}
                error={getErrorState("TermsOfTrade")}
              >
                {termstrade.map((obj: TermsTrade, index: number) => (
                  <MenuItem key={obj.code} value={obj.code}>
                    {obj.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        )}
         { !Common.isVendor() && (<Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.individualPayPopup_instruction_key_lbl}
            </span>
            {vendorDetailMode === VendorRequestViewMode.VendorIndividualPay && !vendorDetail.isIndividualPayement &&
                  <span style={{ float: "left", fontSize: "10px", width: "335px"}}>
                        ({"Please change the instruction key through an amend request If required"})
                  </span>
            }
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
             <span className={classes.textWrapInput}>
                {vendorDetail.InstructionKey}
             </span>
          </Grid>
        </Grid> )}
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_paymethod_lbl}
              <label hidden={getCompareField("PreferedPaymentMethodCode")} className={classes.editedLabel}>EDITED</label>
            </span>
            {vendorDetailMode === VendorRequestViewMode.VendorIndividualPay && !vendorDetail.isIndividualPayement &&
                            <span style={{ float: "left", fontSize: "10px"}}>
                                ({"Please change the payment method through an amend request If required"})
                            </span>
                            }
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
             <Select
                    variant="outlined"
                    multiple
                    value={vendorDetail.PrefPayMethod || []}
                    onChange={handleChange("PrefPayMethod")}
                    //disabled={vendorDetail.isIndividualPayement}
                    disabled
                    error={getErrorState("PrefPayMethod")}
                    renderValue={(selected) => (
                      <div>
                        {(selected as string[]).map((value) => (
                          <Chip
                            key={value}
                            label={value}
                            //clickable
                            // deleteIcon={ isEditableMode ? (
                            //   <CancelIcon
                            //     onMouseDown={(event) => event.stopPropagation()}
                            //   /> ) : undefined
                            // }
                            // onDelete={(e) => handleDelete(e, value, "PrefPayMethod")}
                          />
                        ))}
                      </div>
                    )}
                  >
                    {paymentmethod.map((obj:PaymentMethod, index:number) => (
                      <MenuItem key={obj.code} value={obj.code}>
                        <Checkbox
                          checked={vendorDetail.PrefPayMethod.includes(obj.code)}
                        />
                        <ListItemText primary={obj.name} />
                      </MenuItem>
                    ))}
                  </Select>
            {/* <Select
              variant="outlined"
              value={vendorDetail.PrefPayMethod || ""}
              onChange={handleChange("PrefPayMethod")}
              error={getErrorState("PrefPayMethod")}
            >
              {paymentmethod.map((obj: PaymentMethod, index: number) => (
                <MenuItem key={obj.code} value={obj.code}>
                  {obj.name}
                </MenuItem>
              ))}
            </Select> */}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_credperiod_lbl}
              <label hidden={getCompareField("CreditPeriodCode")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Select
              disabled
              variant="outlined"
              value={vendorDetail.CreditPeriodDays || ""}
              onChange={handleChange("CreditPeriodDays")}
              error={getErrorState("CreditPeriodDays")}
            >
              {crediperioddays.map((obj: CreditPeriodDays, index: number) => (
                <MenuItem key={obj.code} value={obj.code}>
                  {obj.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
        {isPORequest() && (
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_currencyorder_lbl}
              <label hidden={getCompareField("OrderCurrencyCode")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Autocomplete
              disabled
              options={settlementcurrency.map(
                (obj: SettlementCurrency, index: number) => obj
              )}
              getOptionLabel={(option) => option.code}
              filterOptions={filterOptionsOrderCurrency}
              onChange={(e, newValue) => {
                e.preventDefault();
                handleChangeAutoCompete(e, "orderCurrency", newValue);
              }}
              value={
                settlementcurrency.find(
                  (element: SettlementCurrency) =>
                    element.code === vendorDetail.orderCurrency
                ) || null
              }
              renderOption={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  error={getErrorState("orderCurrency")}
                  inputProps={{
                    ...params.inputProps,
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
        )}
        {isPORequest() && (isFielsAvailable("SettlementCurrencies")) && (
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={4}
            className={
              !isEditableMode || !vendorDetail.orderCurrency
                ? classes.compDisableCls
                : ""
            }
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.vendor_detail_paymentdetails_currencyst_lbl}
                <label hidden={getCompareField("SettlementCurrencies")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid
              className={classes.formOneinputWrapper}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Autocomplete
                disabled
                multiple
                options={settlementcurrency.filter(
                  (element: SettlementCurrency) => {
                    return vendorDetail.orderCurrency !== element.code;
                  }
                )}
                disableCloseOnSelect
                value={
                  settlementcurrency.filter((element: SettlementCurrency) =>
                    vendorDetail.alternativeCurrency.includes(element.code)
                  ) || null
                }
                getOptionLabel={(option) => option.name}
                onChange={(e, newValue) => {
                  e.preventDefault();
                  handleChangeAutoCompete(e, "alternativeCurrency", newValue);
                }}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </React.Fragment>
                )}
                renderTags={(value: SettlementCurrency[], getTagProps) =>
                  value.map((option: SettlementCurrency, index: number) => (
                    <Chip label={option.code} {...getTagProps({ index })} />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    error={getErrorState("alternativeCurrency")}
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        )}
        {(isFielsAvailable("IsVatRegistered")) && (
        <Grid
          hidden={!isTaxDetailsAvailable("IsVatRegistered")}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          container
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
            {
              vendorDetail.AddressCoutry == VendorCountry.India 
              && vendorDetail.CompanyCode.countryCode == VendorCountry.India ? 
              translation.vendor_detail_paymentdetails_vat_gst_reg_lbl : translation.vendor_detail_paymentdetails_vatreg_lbl}
              <label hidden={getCompareField("IsVatRegistered")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ width: "50%", float: "left" }}
          >
            <div className={classes.switchDiv}>
              <Switch
                //defaultValue={""}
                //value={vendorDetail.VATRegisterd}
                checked={vendorDetail.VATRegisterd || false}
                onChange={handleChange("VATRegisterd")}
              ></Switch>
            </div>
          </Grid>
        </Grid>)}
        {(isFielsAvailable("IsVatRegistered")) && (
        <Grid
          hidden={ !vendorDetail.VATRegisterd }
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
            {
              vendorDetail.AddressCoutry == VendorCountry.India 
              && vendorDetail.CompanyCode.countryCode == VendorCountry.India ? 
              translation.vendor_detail_paymentdetails_vatregupload_gst_lbl : translation.vendor_detail_paymentdetails_vatregupload_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <div className={classes.fileWrapper}>
              <FileUpload
                editable = {vendorDetail.requestStatusId === RequestStatus.Initial}
                requestNumber={vendorDetail.RequestNumber}
                userfile={vendorDetail.VatFile}
                attachmentType={FileUploadTypes.VATRegistationProof}
              ></FileUpload>
            </div>
          </Grid>
        </Grid>)}
        <Grid
          hidden={!isTaxDetailsAvailable("VatNo")}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {
              vendorDetail.AddressCoutry == VendorCountry.India 
              && vendorDetail.CompanyCode.countryCode == VendorCountry.India ? 
              translation.vendor_detail_paymentdetails_vatno_gst_lbl :translation.vendor_detail_paymentdetails_vatno_lbl}
              <label hidden={getCompareField("VatNo")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            //className={classes.formOneinputWrapper}
            className={
              vendorDetail.VATRegisterd
                ? classes.inputWrapper_Req
                : classes.formOneinputWrapper
            }
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.VATNumber || ""}
              onChange={handleChange("VATNumber")}
              error={getErrorState("VATNumber")}
              inputProps={{ maxLength: FieldsLengthConstants.VATNumber }}
            />
            <span className={classes.helpLbl}>{translation.vendor_detail_paymentdetails_vatno_help}</span>
          </Grid>
        </Grid>
        {(isFielsAvailable("IsSvatRegistered")) && (
        <Grid
          hidden={!isTaxDetailsAvailable("IsSvatRegistered")}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          container
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_svatreg_lbl}
              <label hidden={getCompareField("IsSvatRegistered")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ width: "50%", float: "left" }}
          >
            <div className={classes.switchDiv}>
              <Switch
                //defaultValue={""}
                //value={vendorDetail.SVATRegistered}
                checked={vendorDetail.SVATRegistered || false}
                onChange={handleChange("SVATRegistered")}
              ></Switch>
            </div>
          </Grid>
        </Grid>)}
        {(isFielsAvailable("IsSvatRegistered")) && (
        <Grid
          hidden={ !vendorDetail.SVATRegistered }
          // className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_svatregupload_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <div className={classes.fileWrapper}>
              <FileUpload
                editable = {vendorDetail.requestStatusId === RequestStatus.Initial}
                requestNumber={vendorDetail.RequestNumber}
                userfile={vendorDetail.SvatFile}
                attachmentType={FileUploadTypes.SVATRegistrationProof}
              ></FileUpload>
            </div>
          </Grid>
        </Grid>)}
        <Grid
          hidden={!isTaxDetailsAvailable("SvatContactPhone")}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {
                translation.vendor_detail_paymentdetails_svatcontctper_connum_lbl
              }
                <label hidden={getCompareField("SvatContactPhone")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={
              vendorDetail.SVATRegistered
                ? classes.inputWrapper_Req
                : classes.formOneinputWrapper
            }
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.SVATContactNumber || ""}
              onChange={handleChange("SVATContactNumber")}
              error={getErrorState("SVATContactNumber")}
            />
          </Grid>
        </Grid>
        <Grid
          hidden={!isTaxDetailsAvailable("SvatContactEmail")}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_svatcontctper_email_lbl}
              <label hidden={getCompareField("SvatContactEmail")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={
              vendorDetail.SVATRegistered
                ? classes.inputWrapper_Req
                : classes.formOneinputWrapper
            }
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.SVATContactEmail || ""}
              onChange={handleChange("SVATContactEmail")}
              error={getErrorState("SVATContactEmail")}
            />
          </Grid>
        </Grid>        
        <Grid
          hidden={!isTaxDetailsAvailable("SvatNo")}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_svatno_lbl}
              <label hidden={getCompareField("SvatNo")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            //className={classes.formOneinputWrapper}
            className={
              vendorDetail.SVATRegistered
                ? classes.inputWrapper_Req
                : classes.formOneinputWrapper
            }
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.SVATNumber || ""}
              onChange={handleChange("SVATNumber")}
              error={getErrorState("SVATNumber")}
              inputProps={{ maxLength: FieldsLengthConstants.SVATNumber }}
            />
          </Grid>
        </Grid>
        <Grid
          hidden={!isTaxDetailsAvailable("TinNic")}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_tinnic_lbl}
              <label hidden={getCompareField("TinNicNo")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={
              ((vendorDetail.AddressCoutry === VendorCountry.USA && acmeNOBvalues.includes(vendorDetail.NatureOfbusiness))
               || (vendorDetail.AddressCoutry === VendorCountry.SriLanka))
                ? classes.inputWrapper_Req
                : classes.formOneinputWrapper
            }
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.TinNic || ""}
              onChange={handleChange("TinNic")}
              error={getErrorState("TinNic")}
              inputProps={{ maxLength: FieldsLengthConstants.TINNumber }}
            />
            <span className={classes.helpLbl}>{translation.vendor_detail_paymentdetails_tinnic_help}</span>
          </Grid>
        </Grid>
        <Grid
          hidden={ !isTaxDetailsAvailable("TinNic") }
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_tinupload_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <div className={classes.fileWrapper}>
              <FileUpload
                editable = {vendorDetail.requestStatusId === RequestStatus.Initial}
                requestNumber={vendorDetail.RequestNumber}
                userfile={vendorDetail.TinFile}
                attachmentType={FileUploadTypes.TinDoument}
              ></FileUpload>
            </div>
          </Grid>
        </Grid>
        <Grid
          hidden={!isTaxDetailsAvailable("Tax1099")}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_1099_lbl}
              <label hidden={getCompareField("Tax1099")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={is1099Required() ? classes.inputWrapper_Req : classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Tooltip title={translation.vendor_detail_paymentdetails_1099_msg} arrow>
              <TextField
                variant="outlined"
                value={vendorDetail.Tax1099 || ""}
                onChange={handleChange("Tax1099")}
                error={getErrorState("Tax1099")}
                inputProps={{ maxLength: FieldsLengthConstants.Tax1099 }}
              />
            </Tooltip>
          </Grid>
        </Grid>
        <Grid
          hidden={ !isTaxDetailsAvailable("Tax1099") }
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_1099upload_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <div className={classes.fileWrapper}>
              <FileUpload
                editable = {vendorDetail.requestStatusId === RequestStatus.Initial}
                requestNumber={vendorDetail.RequestNumber}
                userfile={vendorDetail.Tax1099File}
                attachmentType={FileUploadTypes.Tax1099Document}
              ></FileUpload>
            </div>
          </Grid>
        </Grid>
        <Grid
          hidden={!isTaxDetailsAvailable("TaxContactPersonName")}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_taxconperson_lbl}
              <label hidden={getCompareField("TaxContactPersonName")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={
              vendorDetail.VATRegisterd
                ? classes.inputWrapper_Req
                : classes.formOneinputWrapper
            }
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.TaxConPersnName || ""}
              onChange={handleChange("TaxConPersnName")}
              error={getErrorState("TaxConPersnName")}
            />
          </Grid>
        </Grid>
        <Grid
          hidden={!isTaxDetailsAvailable("TaxContactPersonPhone")}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_taxconperdetl_lbl}
              <label hidden={getCompareField("TaxContactPersonPhone")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={
              vendorDetail.VATRegisterd
                ? classes.inputWrapper_Req
                : classes.formOneinputWrapper
            }
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.TaxConPersnConNum || ""}
              onChange={handleChange("TaxConPersnConNum")}
              error={getErrorState("TaxConPersnConNum")}
              inputProps={{ maxLength: FieldsLengthConstants.TaxContactNumber }}
            />
          </Grid>
        </Grid>
        <Grid
          hidden={!isWHTAvailable()}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          container
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_lforwht_lbl}
              <label hidden={getCompareField("LiableForWht")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ width: "50%", float: "left" }}
          >
            <div className={classes.switchDiv}>
              <Switch
                //defaultValue={""}
                //value={vendorDetail.LiableForWHT}
                checked={vendorDetail.LiableForWHT || false}
                onChange={handleChange("LiableForWHT")}
              ></Switch>
            </div>
            <span className={classes.helpLbl}>{translation.vendor_detail_paymentdetails_lforwht_help}</span>
          </Grid>
        </Grid>
        <Grid
          hidden={ !vendorDetail.LiableForWHT }
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_lforwhtpload_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <div className={classes.fileWrapper}>
              <FileUpload
                editable = {vendorDetail.requestStatusId === RequestStatus.Initial}
                requestNumber={vendorDetail.RequestNumber}
                userfile={vendorDetail.WhtFile}
                attachmentType={FileUploadTypes.LiableForWHTAttchmnt}
              ></FileUpload>
            </div>
          </Grid>
        </Grid>
        <Grid
          //hidden={!isAvailableForVendorCountry("WHTCountry")}
          hidden={!isWHTAvailable()}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_whtcountry_lbl}
              <label hidden={getCompareField("WhtcountryCode")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Autocomplete
              options={whtcountries.map((obj: Country, index: number) => obj)}
              getOptionLabel={(option) => option.name}
              onChange={(e, newValue) => {
                e.preventDefault();
                handleChangeAutoCompete(e, "WHTCountry", newValue);
              }}
              value={
                whtcountries.find(
                  (element: Country) => element.code === vendorDetail.WHTCountry
                ) || null
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={getErrorState("WHTCountry")}
                  inputProps={{
                    ...params.inputProps,
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid
          //hidden={!isAvailableForVendorCountry("WHTType")}
          hidden={!isWHTAvailable()}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_whttype_lbl}
              <label hidden={getCompareField("WhttypeCode")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Select
              variant="outlined"
              value={vendorDetail.WHTType || ""}
              onChange={handleChange("WHTType")}
              error={getErrorState("WHTType")}
            >
              {whttypes.map((obj: WHTType, index: number) => (
                <MenuItem key={obj.code} value={obj.code}>
                  {obj.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
        <Grid
          //hidden={!isAvailableForVendorCountry("WHTCode")}
          hidden={!isWHTAvailable()}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_whtcode_lbl}
              <label hidden={getCompareField("Whtcode")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Select
              variant="outlined"
              value={vendorDetail.WHTCode || ""}
              onChange={handleChange("WHTCode")}
              error={getErrorState("WHTCode")}
            >
              {whtcodes.map((obj: WHTCode, index: number) => (
                <MenuItem key={obj.code} value={obj.code}>
                  {obj.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
        <Grid
          //hidden={!isAvailableForVendorCountry("ExemptionNumber")}
          hidden={!isWHTAvailable()}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_exempnum_lbl}
              <label hidden={getCompareField("ExemptionNumber")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              inputProps={{ maxLength: isWHTAvailable() ? FieldsLengthConstants.ExemptionNumberWht : FieldsLengthConstants.ExemptionNumber }}
              value={vendorDetail.ExemptionNumber || ""}
              onChange={handleChange("ExemptionNumber")}
              error={getErrorState("ExemptionNumber")}
            />
          </Grid>
        </Grid>
        <Grid
          //hidden={!isAvailableForVendorCountry("Exemption")}
          hidden={!isWHTAvailable()}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_exemp_lbl}
              <label hidden={getCompareField("ExemptionPercentage")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.Exemption || ""}
              onChange={handleChange("Exemption")}
              error={getErrorState("Exemption")}
            />
          </Grid>
        </Grid>
        <Grid
          //hidden={!isAvailableForVendorCountry("ExemptFrom")}
          hidden={!isWHTAvailable()}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_exempfrm_lbl}
              <label hidden={getCompareField("ExemptFrom")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              type="date"
              value={vendorDetail.ExemptFrom || ""}
              onChange={handleChange("ExemptFrom")}
              error={getErrorState("ExemptFrom")}
            />
          </Grid>
        </Grid>
        <Grid
          //hidden={!isAvailableForVendorCountry("WHTCode")}
          hidden={!isWHTAvailable()}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_exempto_lbl}
              <label hidden={getCompareField("ExemptTo")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              type="date"
              value={vendorDetail.ExemptTo || ""}
              onChange={handleChange("ExemptTo")}
              error={getErrorState("ExemptTo")}
            />
          </Grid>
        </Grid>
        <Grid
          // hidden={!isAvailableForVendorCountry("Discription")}
          hidden={!isWHTAvailable()}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_des_lbl}
              <label hidden={getCompareField("ExemtionDescription")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.Discription || ""}
              onChange={handleChange("Discription")}
              error={getErrorState("Discription")}
              inputProps={{ maxLength: FieldsLengthConstants.ExemDiscription }}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={6}
          lg={4}
          className={!isEditableMode ? classes.compDisableCls : ""}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_forgentryreq_lbl}
              <label hidden={getCompareField("IsForeignEntity")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ width: "50%", float: "left" }}
          >
            {/* <TextField
              variant="outlined"
              value={vendorDetail.ForeignEntityReq || ""}
              onChange={handleChange("ForeignEntityReq")}
              error={getErrorState("ForeignEntityReq")}
            /> */}
            <div className={classes.switchDiv}>
              <Switch
                //defaultValue={""}
                //value={vendorDetail.ForeignEntityReq}
                checked={vendorDetail.ForeignEntityReq || false}
                onChange={handleChange("ForeignEntityReq")}
              ></Switch>
            </div>
          </Grid>
        </Grid>
        <Grid
          hidden={!isTaxDetailsAvailable("AvailabilityOfDoubleTax")}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_avdoubltax_lbl}
              <label hidden={getCompareField("AvailabilityOfDoubleTax")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              disabled={!vendorDetail.ForeignEntityReq}
              variant="outlined"
              value={vendorDetail.AvailabilityDT || ""}
              onChange={handleChange("AvailabilityDT")}
              error={getErrorState("AvailabilityDT")}
            />
          </Grid>
        </Grid>
        {(isFielsAvailable("PanNumber")) && (
        <Grid
          hidden={createVendor.VendorType === VendorTypeData.Employee}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_pannum_lbl}
              <label hidden={getCompareField("PanNumber")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            // className={classes.formOneinputWrapper}
            //className = {vendorDetail.AddressCoutry === VendorCountry.India ? classes.inputWrapper_Req : classes.formOneinputWrapper}
            className={
              isPanTaxRequired()
                ? classes.inputWrapper_Req
                : classes.formOneinputWrapper
            }
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.PANNumber || ""}
              onChange={handleChange("PANNumber")}
              error={getErrorState("PANNumber")}
              inputProps={{ maxLength: FieldsLengthConstants.PANNumber }}
            />
          </Grid>
        </Grid>)}
        {(isFielsAvailable("PanNumber")) && (
        <Grid
          hidden={ createVendor.VendorType === VendorTypeData.Employee }
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_panupload_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <div className={classes.fileWrapper}>
              <FileUpload
                editable = {vendorDetail.requestStatusId === RequestStatus.Initial}
                requestNumber={vendorDetail.RequestNumber}
                userfile={vendorDetail.PanFile}
                attachmentType={FileUploadTypes.PANDocument}
              ></FileUpload>
            </div>
          </Grid>
        </Grid>)}
        {(isFielsAvailable("TaxNumber")) && (
        <Grid
          hidden={createVendor.VendorType === VendorTypeData.Employee}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {vendorDetail.AddressCoutry === VendorCountry.India 
              ? translation.vendor_detail_paymentdetails_tax_msme_num_lbl
              : translation.vendor_detail_paymentdetails_taxnum_lbl}
              <label hidden={getCompareField("TaxNumber")} className={classes.editedLabel}>EDITED</label>
            </span> 
          </Grid>
          <Grid
            //className={classes.formOneinputWrapper}
            //className = {vendorDetail.AddressCoutry === VendorCountry.India ? classes.inputWrapper_Req : classes.formOneinputWrapper}
            className={
              isPanTaxRequired()
                ? classes.inputWrapper_Req
                : classes.formOneinputWrapper
            }
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.TaxNumber || ""}
              onChange={handleChange("TaxNumber")}
              error={getErrorState("TaxNumber")}
              inputProps={{ maxLength: FieldsLengthConstants.TaxNumber }}
            />
          <span className={classes.helpLbl}>{translation.vendor_detail_paymentdetails_taxnum_help}</span>
          </Grid>
        </Grid>)}
        {(isFielsAvailable("TaxNumber")) && (
        <Grid
          hidden={createVendor.VendorType === VendorTypeData.Employee}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {vendorDetail.AddressCoutry === VendorCountry.India 
                ? translation.vendor_detail_paymentdetails_tax_msme_upload_lbl
                : translation.vendor_detail_paymentdetails_tax_upload_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <div className={classes.fileWrapper}>
              <FileUpload
                editable = {vendorDetail.requestStatusId === RequestStatus.Initial}
                requestNumber={vendorDetail.RequestNumber}
                userfile={vendorDetail.TaxFile}
                attachmentType={FileUploadTypes.TaxDocument}
              ></FileUpload>
            </div>
          </Grid>
        </Grid>)}
        {(isFielsAvailable("trc")) && (
        <Grid
          hidden={createVendor.VendorType === VendorTypeData.Employee}
          className={!isEditableMode ? classes.compDisableCls : ""}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_trc_lbl}
              <label hidden={getCompareField("trc")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={
              isTrcRequired()
                ? classes.inputWrapper_Req
                : classes.formOneinputWrapper
            }
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              variant="outlined"
              value={vendorDetail.trc || ""}
              onChange={handleChange("trc")}
              error={getErrorState("trc")}
              //inputProps={{ maxLength: FieldsLengthConstants.TaxNumber }}
            />
          </Grid>
        </Grid>)}
        {(isFielsAvailable("trc")) && (
        <Grid
          hidden={createVendor.VendorType === VendorTypeData.Employee}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_trc_upload_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <div className={classes.fileWrapper}>
              <FileUpload
                editable = {vendorDetail.requestStatusId === RequestStatus.Initial}
                requestNumber={vendorDetail.RequestNumber}
                userfile={vendorDetail.TrcFile}
                attachmentType={FileUploadTypes.TrcDocument}
              ></FileUpload>
            </div>
          </Grid>
        </Grid>)}
        <Grid item container xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_permittedpayee_lbl}
              <label hidden={getCompareField("VendorPermittedPayees")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <div className={classes.addBtnWrapper}>
              {isEditableMode && (
                <Button disabled={vendorDetail.isIndividualPayement} onClick={handlePermittedPayeeAddPress}>
                  <AddCircleIcon></AddCircleIcon>
                  {
                    translation.vendor_detail_paymentdetails_permittedpay_addbtntxt
                  }
                </Button>
              )}
            </div>
            <span className={classes.textWrap}>
              {Util.concateStringArray(vendorDetail.permittedPayeeList)}
            </span>
          </Grid>
        </Grid>
      </Grid>
      <VendorSelectDialog
        open={openPermittedPayeeDialog}
        title={translation.vendordetail_permittedvendor_popup_title}
        handleClose={handlePermittedPayeeClose}
        isEditmode={isEditableMode}
        companyCode={createVendor.CompanyCode}
        onUpdateConfirm={handleUpdatePermittedPayee}
        alreadySelectedVendors={vendorDetail.permittedPayeeList}
        nodataMsg={translation.vendordetail_permittedvendor_popup_nodta_msg}
        maxSelectItems={Max_PermittedPayee_For_Vendor}
        requestMode={vendorDetailMode}
        currentRequestVendor={createVendor.vendorNo}
      ></VendorSelectDialog>
    </div>
  );
}
